import React, { useCallback, useEffect, useState } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import APIS from './apis/apis';
import './App.css';
import SVGIcon from './assets/svg/SvgIcon';
import SVGIcon2 from './assets/svg/SVGIcon2';
import SVGIcon3 from './assets/svg/SVGIcon3';
import SVGIcon4 from './assets/svg/SVGIcon4';
import SVGIcon5 from './assets/svg/SVGIcon5';
import MaintenanceGate from './components/common/MaintenanceGate';
import './index.css';
import './perf.css';
import MobileAccount from './pages/Mobile/Account';
import AccountRecord from './pages/Mobile/AccountRecord';
import BettingRecord from './pages/Mobile/BettingRecord';
import BiundEwallet from './pages/Mobile/BindEwallet';
import ChangePassword from './pages/Mobile/ChangePassword';
import Deposit from './pages/Mobile/Deposit';
import DepositRecord from './pages/Mobile/DepositRecord';
import EwalletList from './pages/Mobile/EwalletList';
import EXHome from './pages/Mobile/Exchange';
import EXHomeVelki from './pages/Mobile/EXHomeVelki';
import GameRun from './pages/Mobile/GameRun';
import NineWiket from './pages/Mobile/NineWiket';
import MobileHome from './pages/Mobile/Home';
import Inbox from './pages/Mobile/Inbox';
import Invite from './pages/Mobile/Invite';
import MobileLogin from './pages/Mobile/Login';
import MakePayment from './pages/Mobile/MakePayment';
import Mission from './pages/Mobile/Mission';
import PersonalInformation from './pages/Mobile/PersonalInformation';
import ProfitANDLoss from './pages/Mobile/ProfitANDLoss';
import Promotion from './pages/Mobile/Promotion';
import RebateBouns from './pages/Mobile/RebetBouns';
import RewadCenter from './pages/Mobile/RewadCenter';
import SecurityCenter from './pages/Mobile/SecurityCenter';
import ShowPromotion from './pages/Mobile/ShowPromotion';
import MobileSiginUp from './pages/Mobile/SiginUp';
import Withdrawal from './pages/Mobile/Withdrawals';
import WithdrawRecord from './pages/Mobile/WithdrawRecord';
import Splash from './splash/Splash';
import StoreCode from './StoreCodeComponents';
import Games from './components/pages/mobile/Games';
import ForgotPasswordRequest from './components/auth/ForgotPasswordRequest';
import ForgotPasswordVerify from './components/auth/ForgotPasswordVerify';
import ForgotPasswordUnified from './components/auth/ForgotPasswordUnified';
import FreeSpinPage from './free-spin/FreeSpinPage';
const isMobile = () => /Mobi|Android/i.test(navigator.userAgent);
function App() {
  const isDeviceMobile = isMobile();

  // ── /#/9wkt exit handler ──────────────────────────────────────────────────
  // When 9WKT game redirects back with /#/9wkt in the URL, POST exit to backend
  // then strip the hash segment so the app loads cleanly.
  useEffect(() => {
    if (window.location.href.includes('/#/9wkt')) {
      const token = localStorage.getItem('token');
      fetch(`${process.env.REACT_APP_API_URL}/api/9wkt/exit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      }).finally(() => {
        const cleanUrl = window.location.href.split('/#/9wkt')[0];
        window.location.replace(cleanUrl);
      });
    }
  }, []);
	const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem('token'));
	const [showContent, setShowContent] = useState(false);
	const [logo, setLogo] = useState([]);
	const [isDataLoaded, setIsDataLoaded] = useState(false); 
	const location = useLocation();
	const [globalData, setGlobalData] = useState({});
	const [showModal, setShowModal] = useState(false);
	const [modalMessage, setModalMessage] = useState('');
	const [balance, setBalance] = useState(0);
	const [refreshPvtData, setRefreshPvtData] = useState(false);
	const [color, setColor] = useState(false);
  const [pwaIconUrl, setPwaIconUrl] = useState(null);
  const [pwaSiteName, setPwaSiteName] = useState(null);


  const triggerPrivateRefresh = () => {
    setRefreshPvtData(prev => prev + 1);
  };

	const showAlert = (message = false) => { 
		if (!message) { 
			setShowModal(false);
			return;
		}
		setShowModal(true);
		setModalMessage(message);
	};
	

  const isHome = location.pathname === "/" || location.pathname === "/home";
  const bodyClass = isHome ? "yesbbdtf3 outter-app" : "yesbbdtf3 mc-layout-wrapper";

	React.useEffect(() => {
		const body = document.body;
		const keepBodyBg = body.classList.contains('body-bg');
		body.className = bodyClass;
		if (keepBodyBg) {
			body.classList.add('body-bg');
		}
	}, [bodyClass]);

  // Function to dynamically set the favicon
  const setFavicon = (url) => {
    if (!url) return;
    let link = document.querySelector("link[rel='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = url;
  };
  const [cssLoading, setCssLoading] = useState(false);

  // Fetch promotions data and set logo & favicon
  useEffect(() => {
    const fetchPromotions = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/logo`);
        if (!response.ok) {
          throw new Error("Failed to fetch promotions");
        }
        const data = await response.json();
        setLogo(data[0].loader_logo);
        if (data[0]?.favicon) {
          const faviconUrl = data[0].favicon.startsWith('http')
            ? data[0].favicon
            : `${process.env.REACT_APP_API_URL}/storage/${data[0].favicon}`;
          setFavicon(faviconUrl);
          // prefer logo field if available, otherwise use favicon for PWA icon
          const pwaIcon = data[0]?.logo
            ? (data[0].logo.startsWith('http') ? data[0].logo : `${process.env.REACT_APP_API_URL}/storage/${data[0].logo}`)
            : faviconUrl;
          setPwaIconUrl(pwaIcon);
        }
        console.log(data[0].loader_logo);
      } catch (error) {
        console.error("Error fetching promotions:", error);
      }
    };

    fetchPromotions();
  }, []);

  // Fetch general site data
useEffect(() => {
	const fetchGeneral = async () => {
		let token = localStorage.getItem('token');
		let headers = {
			'Authorization': `Bearer ${token}`
		};
		if (!token) {
			headers = {};
		}
		try {
			const response = await fetch(`${process.env.REACT_APP_API_URL}/api/general`, {
				headers: headers
			});
			if (!response.ok) {
				throw new Error("Failed to fetch General");
			}
			const data = await response.json();
			if (data) {
				document.title = data[0].site_title;
				setPwaSiteName(data[0].site_title);
				console.log(data[0]?.site_title);
				localStorage.setItem('whatsapp', data[0]?.whatsapp);
				localStorage.setItem('liveChat', data[0]?.live_chat);
				localStorage.setItem('intercom', data[0]?.intercom);
				localStorage.setItem('tawkId', data[0]?.tawk_id);
			}
		} catch (error) {
			console.error("Error fetching General:", error);
		}
	};

	fetchGeneral();
}, []);

  // Dynamically update the PWA manifest once site name and icon are fetched
  useEffect(() => {
    if (!pwaSiteName && !pwaIconUrl) return;
    const manifestData = {
      short_name: pwaSiteName || document.title,
      name: pwaSiteName || document.title,
      start_url: '/',
      display: 'standalone',
      theme_color: '#000000',
      background_color: '#ffffff',
      icons: pwaIconUrl
        ? [
            { src: pwaIconUrl, sizes: '192x192', type: 'image/png' },
            { src: pwaIconUrl, sizes: '512x512', type: 'image/png' },
          ]
        : [],
    };
    const blob = new Blob([JSON.stringify(manifestData)], { type: 'application/json' });
    const manifestUrl = URL.createObjectURL(blob);
    let manifestLink = document.querySelector("link[rel='manifest']");
    if (!manifestLink) {
      manifestLink = document.createElement('link');
      manifestLink.rel = 'manifest';
      document.head.appendChild(manifestLink);
    }
    manifestLink.href = manifestUrl;
    return () => URL.revokeObjectURL(manifestUrl);
  }, [pwaSiteName, pwaIconUrl]);

	// Mark data as loaded after we have at least one branding datum
	useEffect(() => {
		if (logo) {
			setIsDataLoaded(true);
		}
	}, [logo]);
		useEffect(() => {
  const hostname = (window.location.hostname || '').toLowerCase();
  const origin = (window.location.origin || '').toLowerCase();
  const search = (window.location.search || '').toLowerCase();
  const params = new URLSearchParams(window.location.search);
  const brand = ((process.env.REACT_APP_BRAND || localStorage.getItem('brand') || '')).toLowerCase();

  const isJW88 = hostname.includes('jw88') || origin.includes('jw88') || brand.includes('jw88');
  const isLocalhost = hostname.includes('localhost') || origin.includes('localhost') || brand.includes('localhost');
	const isBk8bd = hostname.includes('bk8bd') || origin.includes('bk8bd') || brand.includes('bk8bd');
	const isCb444 = hostname.includes('cb444') || origin.includes('cb444') || brand.includes('cb444');
	const isKrikiya = hostname.includes('krikiya') || origin.includes('krikiya') || brand.includes('krikiya');

	const selectedBrand = isKrikiya ? 'krikiya' : isJW88 ? 'jw88' : isLocalhost ? 'localhost' : (isBk8bd || isCb444) ? 'bk8bd' : 'default';

  localStorage.setItem('brand', selectedBrand);

  
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.type = 'text/css';
  link.href = `${selectedBrand}.css?ver=${Date.now()}`;
  document.head.appendChild(link);

  setColor(isJW88 || isLocalhost);

  return () => {
    const existing = document.querySelectorAll(`link[href*="${selectedBrand}.css"]`);
    existing.forEach(el => el.remove());
  };
}, []);


  

  const fetchBalance = useCallback(async () => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/balance`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });
  
        if (response.ok) {
			const data = await response.json();
		
			localStorage.setItem('balance', data.balance);
			if (document.querySelector('.mainBalance')) {
				document.querySelector('.mainBalance').innerHTML = data.balance;
			}
			
        } else if (response.status === 401) {
          handleLogout();
        }
      } catch (error) {
        console.error('Error fetching balance:', error);
      }
    } else {
      console.warn('No token found in local storage.');
    }
  }, []); 
	
	

  const handleLogout = () => {
    localStorage.clear();
    setIsLoggedIn(false);
    window.location.href = '/home';
  };

  useEffect(() => {
    if (isLoggedIn) {
      fetchBalance();
      const interval = setInterval(fetchBalance, 10000);
      return () => clearInterval(interval);
    }
  }, [isLoggedIn, fetchBalance]);


  const PrivateRoute = ({ element }) => {
    return isLoggedIn ? element : <Navigate to="/login" />;
  };
const [gtmId, setGtmId] = useState(null);

  useEffect(() => {
    const id = globalData?.general?.google_tag;
    if (!id) return;

    setGtmId(id);

    if (typeof window !== "undefined") {
      window.dataLayer = window.dataLayer || [];
    }

    // ✅ ডুপ্লিকেট স্ক্রিপ্ট থাকলে remove করো
    const oldScript = document.getElementById("gtm-script");
    if (oldScript) oldScript.remove();

    
    const script = document.createElement("script");
    script.id = "gtm-script";
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${id}`;
    document.head.appendChild(script);

   
    window.dataLayer.push({
      "gtm.start": new Date().getTime(),
      event: "gtm.js",
    });


    // cleanup optional
    return () => {
      const s = document.getElementById("gtm-script");
      if (s) s.remove();
    };
  }, [globalData]);



	return (
    <div>
	  {gtmId && (
        <noscript>
          <iframe
            src={`https://www.googletagmanager.com/ns.html?id=${gtmId}`}
            height="0"
            width="0"
            style={{ display: "none", visibility: "hidden" }}
            title="gtm"
          ></iframe>
        </noscript>
      )}
      {/* 🌐 Load initial global + private API data */}
      <APIS setGlobalData={setGlobalData} refreshPvtData={refreshPvtData} />

			{/* Splash overlays for 2s with fade, then reveals content */}
			{!showContent && (
				<Splash onSplashComplete={() => setShowContent(true)} />
			)}

      {/* 🔷 Global SVG assets */}
      <SVGIcon />
      <SVGIcon3/>
      <SVGIcon4/>
      <SVGIcon5/>
      <svg className="svg-gradient">
        <linearGradient id="vendor-linear" x1={18} y1="28.5103" x2={18} y2="8.71443" gradientUnits="userSpaceOnUse">
          <stop stopColor="#006540" />
          <stop offset={1} stopColor="#00D47E" />
        </linearGradient>
        <linearGradient id="common-gradient" x1="16.6005" y1="0.0556641" x2="16.6005" y2="11.6957" gradientUnits="userSpaceOnUse">
          <stop stopColor="#DBF1FB" />
          <stop offset="0.455" stopColor="#A6B9C2" />
          <stop offset="0.74" stopColor="#DBF1FB" />
          <stop offset={1} stopColor="#A6B9C2" />
        </linearGradient>
        <linearGradient id="common-gradient-2" x1="20.5" y1="4.5" x2="20.5" y2="35.5" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FFE799" />
          <stop offset="0.333333" stopColor="#FFD753" />
          <stop offset="0.666667" stopColor="#FFE799" />
          <stop offset={1} stopColor="#F59407" />
        </linearGradient>
      </svg>
      <SVGIcon2 />

	{/* 🧭 App Routes - render after splash finishes */}
	{showContent && (
		<Routes>
				<Route
					path="/forgot-password"
					element={
						<MaintenanceGate
							endpoint={`${process.env.REACT_APP_API_URL}/api/general`}
							transform={(json) => {
								const obj = Array.isArray(json) ? (json[0] || {}) : (json || {});
								return {
									maintenance: String(obj.site_status) === '0',
									message: obj.site_notice || obj.message || ''
								};
							}}
						>
							<ForgotPasswordRequest showAlert={showAlert} />
						</MaintenanceGate>
					}
				/>
				<Route
					path="/forgot-password-unified"
					element={
						<MaintenanceGate
							endpoint={`${process.env.REACT_APP_API_URL}/api/general`}
							transform={(json) => {
								const obj = Array.isArray(json) ? (json[0] || {}) : (json || {});
								return {
									maintenance: String(obj.site_status) === '0',
									message: obj.site_notice || obj.message || ''
								};
							}}
						>
							<ForgotPasswordUnified showAlert={showAlert} />
						</MaintenanceGate>
					}
				/>
				<Route
					path="/forgot-password/verify"
					element={
						<MaintenanceGate
							endpoint={`${process.env.REACT_APP_API_URL}/api/general`}
							transform={(json) => {
								const obj = Array.isArray(json) ? (json[0] || {}) : (json || {});
								return {
									maintenance: String(obj.site_status) === '0',
									message: obj.site_notice || obj.message || ''
								};
							}}
						>
							<ForgotPasswordVerify showAlert={showAlert} />
						</MaintenanceGate>
					}
				/>
        <Route
          path="/home"
						element={
							<MaintenanceGate
								endpoint={`${process.env.REACT_APP_API_URL}/api/general`}
								transform={(json) => {
									const obj = Array.isArray(json) ? (json[0] || {}) : (json || {});
									return {
										maintenance: String(obj.site_status) === '0',
										message: obj.site_notice || obj.message || ''
									};
								}}
							>
								<MobileHome
									globalData={globalData}
									sociallink={globalData.socialLinks || {}}
									triggerPrivateRefresh={triggerPrivateRefresh}
								/>
							</MaintenanceGate>
						}
        />
						<Route path="/free-spin" element={<FreeSpinPage />} />
					<Route
						path="/login"
						element={
							<MaintenanceGate
								endpoint={`${process.env.REACT_APP_API_URL}/api/general`}
								transform={(json) => {
									const obj = Array.isArray(json) ? (json[0] || {}) : (json || {});
									return {
										maintenance: String(obj.site_status) === '0',
										message: obj.site_notice || obj.message || ''
									};
								}}
							>
								<MobileLogin />
							</MaintenanceGate>
						}
					/>
					<Route
						path="/signup"
						element={
							<MaintenanceGate
								endpoint={`${process.env.REACT_APP_API_URL}/api/general`}
								transform={(json) => {
									const obj = Array.isArray(json) ? (json[0] || {}) : (json || {});
									return {
										maintenance: String(obj.site_status) === '0',
										message: obj.site_notice || obj.message || ''
									};
								}}
							>
								<MobileSiginUp />
							</MaintenanceGate>
						}
					/>
       	<Route
					path="/member"
					element={
					<PrivateRoute
						element={
						<MobileAccount
							refreshPrivateData={triggerPrivateRefresh}
							userData={globalData.userData}
							general={globalData.general || {}}          
							sociallink={globalData.socialLinks || {}}  
							
						/>
						}
					/>
					}
				/>
        	<Route
					path="/rewardcenter"
					element={
					<PrivateRoute
						element={
						<RewadCenter
							refreshPrivateData={triggerPrivateRefresh}
							userData={globalData.userData}
							general={globalData.general || {}}          
							sociallink={globalData.socialLinks || {}}  
						/>
						}
					/>
					}
				/>
        <Route
					path="/bettingRecord"
					element={
					<PrivateRoute
						element={
						<BettingRecord
						
						/>
						}
					/>
					}
				/>
				  <Route
					path="/activityDetail"
					element={
					<PrivateRoute
						element={
						<ShowPromotion
						
						/>
						}
					/>
					}
				/>
				
         <Route
					path="/profitandloss"
					element={
					<PrivateRoute
						element={
						<ProfitANDLoss
						
						/>
						}
					/>
					}
				/>
        <Route
					path="/depositRecord"
					element={
					<PrivateRoute
						element={
						<DepositRecord
						 transactionData={globalData.transactions || [] }
						/>
						}
					/>
					}
				/>
         <Route
					path="/withdrawRecord"
					element={
					<PrivateRoute
						element={
						<WithdrawRecord
						 transactionData={globalData.transactions || [] }
						
						/>
						}
					/>
					}
				/>
         <Route
					path="/transactionRecord"
					element={
					<PrivateRoute
						element={
						<AccountRecord
						 transactionData={globalData.transactions || [] }
						/>
						}
					/>
					}
				/>
        
         <Route
					path="/personalInformation"
					element={
					<PrivateRoute
						element={
						<PersonalInformation
						userData={globalData.userData}
						/>
						}
					/>
					}
				/>
          <Route
					path="/changePassword"
					element={
					<PrivateRoute
						element={
						<ChangePassword
						showAlert={showAlert}
						
						/>
						}
					/>
					}
				/>
				<Route
					path="/securityCenter"
					element={
					<PrivateRoute
						element={
							
						<SecurityCenter
						showAlert={showAlert}
						userData={globalData.userData}
						
						/>
						}
					/>
					}
				/>
				<Route
					path="/ewalletList"
					element={
					<PrivateRoute
						element={
						<EwalletList
						showAlert={showAlert}
						
						/>
						}
					/>
					}
				/>
				<Route
					path="/addEwallet"
					element={
					<PrivateRoute
						element={
						<BiundEwallet
						showAlert={showAlert}
						
						/>
						}
					/>
					}
				/>
         <Route
					path="/referral"
					element={
					<PrivateRoute
						element={
						<Invite
						showAlert={showAlert} userData={globalData.userData}
						/>
						}
					/>
					}
				/>
         <Route
					path="/mission"
					element={
					<PrivateRoute
						element={
						<Mission
							turnovers={globalData.turnovers || []}
							transactionAmount={globalData.transactionAmount || 0}
							userData={globalData.userData || {}}
						/>
						}
					/>
					}
				/>
         <Route
					path="/rebateBonus"
					element={
					<PrivateRoute
						element={
						<RebateBouns
						
						/>
						}
					/>
					}
				/>
				 <Route
					path="/exchange"
					element={
					<PrivateRoute
						element={
						<EXHome
						
						/>
						}
					/>
					}
				/>
				<Route path="/9wiket" element={<NineWiket />} />
				<Route
					path="/velki"
					element={
					<PrivateRoute
						element={
						<EXHomeVelki />
						}
					/>
					}
				/>
				<Route path="/make-payment" element={<MakePayment hasEWallet={globalData.hasEWallet} userData={globalData.userData || [] } />} />
				<Route path="/referral_code" element={<StoreCode codeType="referral_code" />} />
				<Route path="/affiliate_code" element={<StoreCode codeType="affiliate_code" />} />
        <Route path="/agent_code" element={<StoreCode codeType="agent_code" />} />
         <Route
					path="/deposit"
					element={
					<PrivateRoute
						element={
						<Deposit
						usdtRate={globalData?.general?.usdt_rate} hasEWallet={globalData.hasEWallet} userData={globalData.userData || [] } transactionData={globalData.transactions || [] } items={globalData.paymentMethods || []}  promotions={globalData.promotions?.activePromotion || []}
						/>
						}
					/>
					}
				/>
         <Route
					path="/Withdraw"
					element={
					<PrivateRoute
						element={
						<Withdrawal
						general={globalData.general} hasEWallet={globalData.hasEWallet} userData={globalData.userData || [] } transactionData={globalData.transactions || [] } items={globalData.paymentMethods || []}
						/>
						}
					/>
					}
				/>
				 <Route
					path="/gamerun"
					element={
					<PrivateRoute
						element={
						<GameRun
						
						/>
						}
					/>
					}
				/>
				 <Route
					path="/promotion"
					element={
					<PrivateRoute
						element={
						<Promotion
						 promotions={globalData.promotions?.allPromotions || []}
						
						/>
						}
					/>
					}
				/>
				 <Route
					path="/inbox"
					element={
					<PrivateRoute
						element={
						<Inbox
						
						
						/>
						}
					/>
					}
				/>
				<Route path="*" element={<Navigate to="/home" />} />
				<Route path="/games" element={<Games />} />
							</Routes>
			)}
    </div>
  );
}

export default App;
